<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardHeader>
          <CCol>
            <strong>{{ $lang.comboOffer.crud.detail }}</strong>
            <back-to-list></back-to-list>
          </CCol>
        </CCardHeader>
        <CCardBody>
          <CTabs add-tab-classes="mt-1">
            <span @click="selected = 'ComboOfferDetail'">
              <CTab>
                <template slot="title">
                  {{ $lang.comboOffer.crud.detail }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'ComboOfferMedia'">
              <CTab>
                <template slot="title">
                  {{ $lang.comboOffer.crud.view_media }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'ComboOfferResponse'">
              <CTab>
                <template slot="title">
                  {{ $lang.comboOffer.crud.view_response }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'ComboOfferReport'">
              <CTab>
                <template slot="title">
                  {{ $lang.comboOffer.crud.view_report }}
                </template>
              </CTab>
            </span>
          </CTabs>
          <component
              :is="selected"
              @changeSelected="getTab($event)"
              style="margin-top: 20px"
          ></component>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import {Mixin} from "/src/mixins/index.js";
import ComboOfferMedia from "./tab/ComboOfferMedia";
import ComboOfferDetail from "./tab/ComboOfferDetail";
import ComboOfferReport from "./tab/ComboOfferReport";
import ComboOfferResponse from "./tab/ComboOfferResponse";
import BackToList from "/src/views/backToList.vue";

export default {
  name: "ComboOfferView",
  mixins: [Mixin],
  components: {
    ComboOfferDetail,
    ComboOfferMedia,
    ComboOfferReport,
    ComboOfferResponse,
    BackToList,
  },
  data() {
    return {
      userId: "",
      tabs: ["ComboOfferDetail", "ComboOfferMedia", "ComboOfferReport", "ComboOfferResponse", "ComboOfferResource"],
      selected: "ComboOfferDetail",
      currentId: "",
      backToListFlag: "",
    };
  },
  mounted() {
    let self = this;
    const id = this.$route.params.id;
    self.userId = this.$route.params.ids;
    self.currentId = id;
  },
  methods: {
    backToList(userId) {
      if (userId != null) {
        this.$router.push({path: "/profile/all/" + userId});
      }
    },
    getTab(tab) {
      let self = this;
      self.selected = tab;
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
